import React, { useEffect, useState } from 'react'
import useCorsi from '../../hooks/useCorsi'
import { useNavigate } from 'react-router';
import CustomModal from '../../components/CustomModal/CustomModal';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import CustomTable from '../../components/CustomTable/CustomTable';
import useCorsoConfigTable from '../../configTable/useCorsoConfigTable';
import { ACTION_TYPES } from '../../model/actions';
import { TIPO_CORSO } from '../../model/tipoCorso';
// NUOVO: Import del nuovo componente modal
import ApplicaScontoPartner from '../../components/ApplicaScontoPartner/ApplicaScontoPartner';
import StatisticheRegioneModal from '../../components/StatisticheRegioneModal/StatisticheRegioneModal';

const GestioneCorsiPage = () => {
  const navigate = useNavigate(); 
  // NUOVO: Aggiunta la funzione applyPartnerSconto, che dovrai implementare nel tuo hook
  const {loadingStateCorsi, deleteCorso, getCorsiByParams, updateStateCorso, modalStateCorsi, setModalStateCorsi} = useCorsi(); 
  const [selectedCorso, setSelectedCorso] = useState(null)
  const [corsi, setCorsi] = useState([]);
  const [showDeleteCorsoModal, setShowDeleteCorsoModal] = useState(false);
  const userLoggedIn = useSelector(state => state?.user?.userData);

  // NUOVO: State per il modal di applicazione sconto
  const [showApplicaScontoModal, setShowApplicaScontoModal] = useState(false);
  const [showStatisticheRegioneModal, setShowStatisticheRegioneModal] = useState(false);

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingCorsi, setIsLoadingCorsi] = useState(false);
  
  const corsoConfigTable = useCorsoConfigTable();

  useEffect(() => {
    if (!isLoadingCorsi) {
      printAllCorsi();
    }
  }, [orderBy, orderType, selectedPage]);

  
  const fetchCorsi = async (obj) => {
    setIsLoadingCorsi(true);
    obj = {
      ...obj,
      filtri: { ...obj.filtri }
    };
    const fetchCorsiList = await getCorsiByParams(obj);
    const countPagination = Math.ceil(fetchCorsiList?.count / obj.limite);
    let corsiList = fetchCorsiList?.data ?? [];
    setTotalPages(countPagination);
    setCorsi(corsiList);
    setIsLoadingCorsi(false);
  }

  const printAllCorsi = async() => {
    let obj = {
      filtri: { ...formDataFilter },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "denominazione"} ${orderType ?? "asc"}`
    };
    await fetchCorsi(obj);
  }

  const onFilteredTable = async () => {
    setSelectedPage(1);
    let obj = {
      filtri: { ...formDataFilter },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "denominazione"} ${orderType ?? "asc"}`
    };
    await fetchCorsi(obj);
  };

  const onDeleteCorso = async () => {
    let obj = {id_corso : selectedCorso?.id_corso}
    const res = await deleteCorso(obj);
    if(res) {
      setShowDeleteCorsoModal(false)
      printAllCorsi();
    }
  }

  const openDeleteModal = (corso) => {
    setSelectedCorso(corso)
    setShowDeleteCorsoModal(true); 
  };
  
  const handleCloseDeleteCorsoModal = () => {
    setShowDeleteCorsoModal(false); 
  };

  const handleAddContenutiCorso = (corso) => {
    navigate(`/aggiungi-contenuti`, { state: { createdCorso: corso } });
  }

  const handleEditCorso = (courseDataPerEdit) => {
    navigate(`/crea-corso`, { state: { courseDataPerEdit } });
  };

  const renderSelectedDeleteCorso = () => (
      <span className="fs-5" style={{wordBreak: "break-word"}}>Vuoi eliminare il corso "<b>{selectedCorso?.denominazione}</b>"?</span>
  );

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const openChangeStateCorso = async (corso) => {
    setSelectedCorso(corso)
    setModalStateCorsi(state => ({ ...state, showModalUpdateStateCorso: true }));
  }
  
  const onUpdateStateCorso = async () => {
    const obj = {
      id_corso: selectedCorso?.id_corso,
      attivo: (selectedCorso?.attivo == "0") ? "1" : "0" 
    };
    await updateStateCorso(obj);
    printAllCorsi();
  }

  const handleCloseModal = () => {
    setModalStateCorsi(state => ({ 
       ...state,
       showModalUpdateStateCorso: false,
      }));
  }

  const renderChangeState = () => (
    <div>
      <span className="fs-5 d-block mb-3" style={{wordBreak: "break-word"}}>
        Vuoi {selectedCorso?.attivo == "1" ? "disattivare" : "attivare"} il corso "<b>{selectedCorso?.denominazione}</b>"?
      </span>
      <div className="alert alert-primary">
        <i className="bi bi-info-circle me-2"></i>
        Cambiando lo stato del corso, il corso "<b>{selectedCorso?.denominazione}</b>" {selectedCorso?.attivo == "1" ? "non sarà più" : "diventerà"} visibile e acquistabile dagli utenti sulla piattaforma.
      </div>
    </div>
  );

  const handleConfigEsami = (corso) => {
    const classe = { ...corso.classi[0], corso: corso };
    navigate("/configura-esami", {state: {classeData: classe}});
  }

  // NUOVO: Funzione per aprire il modal di applicazione sconto per i partner
  const openApplicaScontoModal = (corso) => {
    setSelectedCorso(corso);
    setShowApplicaScontoModal(true);
  };

  // MODIFICATO: Le azioni ora sono dinamiche in base al ruolo
  const getActionsByRole = () => {
    if (userLoggedIn.role === ROLES.PARTNER) {
        return [
            {
              label: "Corsisti",
              icon: 'bi-mortarboard-fill',
              type: ACTION_TYPES.CONFIG,
              condition: () => true, // Sempre visibile per il partner
              onClick: (corso) => navigate("/gestione-corsi-utenti", {state: {courseData: corso}})
            },
        ];
    }

    // Azioni di default per Admin, Developer, etc.
    return [
      {
        label: "Corsisti",
        icon: 'bi-mortarboard-fill',
        type: ACTION_TYPES.CONFIG,
        condition: () => userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER || userLoggedIn.role === ROLES.PARTNER,
        onClick: (corso) => navigate("/gestione-corsi-utenti", {state: {courseData: corso}})
      },
      {
        label: "Argomenti",
        icon: 'bi-list',
        type: ACTION_TYPES.CONFIG,
        onClick: (corso) => navigate("/configura-argomenti", {state: {courseData: corso}})
      },
      {
        label: "Esami",
        icon: 'bi-calendar-event',
        type: ACTION_TYPES.CONFIG,
        condition: (corso) => corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA,
        onClick: (corso) => handleConfigEsami(corso)
      },
      {
        label: "Contenuti",
        icon: 'bi-file-earmark-play',
        type: ACTION_TYPES.CONFIG,
        onClick: (corso) => handleAddContenutiCorso(corso)
      },
      {
        label: "Rendicontazione Regione",
        icon: 'bi-clipboard2-pulse',
        type: ACTION_TYPES.CONFIG,
        condition: (corso) =>
          corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA
          && (userLoggedIn.role === ROLES.ADMIN
            || userLoggedIn.role === ROLES.COURSE_DESIGNER
            || userLoggedIn.role === ROLES.DEVELOPER),
        onClick: (corso) => {
          setSelectedCorso(corso);
          setShowStatisticheRegioneModal(true);
        }
      },
      {
        label: ACTION_TYPES.UPDATE,
        icon: 'bi-pencil-fill text-warning',
        type: ACTION_TYPES.MANAGER,
        condition: () => userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER,
        onClick: (corso) => handleEditCorso(corso)
      },
      {
        label: ACTION_TYPES.DELETE,
        icon: 'bi-trash-fill text-danger',
        type: ACTION_TYPES.MANAGER,
        condition: () => userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER,
        onClick: (corso) => openDeleteModal(corso)
      },
      {
        label: "Stato",
        icon: (corso) => corso.attivo == "1" ? "bi-toggle-on text-success" : "bi-toggle-off text-danger",
        type: ACTION_TYPES.MANAGER,
        condition: (corso) => (userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA,
        onClick: (corso) => openChangeStateCorso(corso)
      }
    ];
  }

 /*
  if(userLoggedIn.role === ROLES.PARTNER && userLoggedIn?.role_superpartner == 0){
    return (<div className='align-self-center my-2'>
              NON SEI AUTORIZZATO!
            </div>);
  }
    */

  return ( 
    <>
      <div className={`card custom-card w-100 shadow p-3`}>
          <div className='container'>
            <div className='d-flex justify-content-between custom-card-header'>
              <div className='d-flex gap-3 custom-card-title my-2'>
                <div className={`custom-icon-container`}>
                  <i className={`bi custom-icon bi-mortarboard fs-2`}></i>
                </div>
                <div className='align-self-center'>
                  <span className='fs-4 d-block'><i><b>Gestione corsi</b></i></span>
                </div>
              </div>
              {
                (userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.DEVELOPER) && (
                  <div className='align-self-center my-2'>
                    <button type='button' className='btn btn-primary' onClick={() => navigate("/crea-corso")}>Crea corso</button>
                  </div>
                )
              }
            </div>
            <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateCorsi.isLoadingCorsiByParams}
                  searchNodeType={[
                    {nodeType: "input", name: "denominazione"},
                    {nodeType: "input", name: "codice"},
                    {nodeType: "select", name: "modalita_erogazione"},
                  ]}
                />
              </div>
            {loadingStateCorsi.isLoadingCorsiByParams ? (
                 <LoadingTable loadingCol={7}/>
            ) : (
              <>
              {(!corsi || corsi.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono corsi da mostrare.</p>
                    </div>
                 ) : ( 
                  <>
                    <CustomTable
                      data={corsi}
                      actions={getActionsByRole()} // MODIFICATO: Uso la funzione dinamica
                      columns={corsoConfigTable}
                      handleOrder={handleOrder}
                      orderBy={orderBy}
                      orderType={orderType}
                    />
                    <div className="d-flex justify-content-end mt-1">
                      <CustomPagination
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        handlePageChange={handlePageChange}
                      />
                    </div>    
                  </>
                  )
                }
              </>
            )}
          </div>
      </div>
  
       <CustomModal
          show={showDeleteCorsoModal}
          onHide={handleCloseDeleteCorsoModal}
          headerText="Elimina corso"
          size={"md"}
          btnText={"Elimina"}
          variant={"danger"}
          body={renderSelectedDeleteCorso()} 
          onSave={onDeleteCorso}
          closeButton={true}
          isLoading={loadingStateCorsi.isLoadingCorsoDeleting}
          onUndoChanges={handleCloseDeleteCorsoModal} 
        />
      <CustomModal
          show={modalStateCorsi.showModalUpdateStateCorso}
          onHide={handleCloseModal}
          headerText="Aggiorna stato"
          size={"md"}
          btnText={selectedCorso?.attivo == "0" ? "Attiva" : "Disattiva"}
          variant={"success"}
          body={renderChangeState()} 
          isLoading={loadingStateCorsi.isLoadingUpdateStateCorso}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onUpdateStateCorso} 
        />
      
      {/* NUOVO: Rendering del nuovo modal per i partner */}
      {showApplicaScontoModal && (
        <ApplicaScontoPartner 
            show={showApplicaScontoModal}
            onHide={() => setShowApplicaScontoModal(false)}
            corso={selectedCorso}
            partnerId={userLoggedIn?.id_utente}
            onScontoApplied={printAllCorsi} // Ricarica la lista corsi dopo l'applicazione
        />
      )}

      <StatisticheRegioneModal
        show={showStatisticheRegioneModal}
        onHide={() => setShowStatisticheRegioneModal(false)}
        corso={selectedCorso}
      />
    </>
  );
}

export default GestioneCorsiPage;
